<div class="sb-nav-fixed">
  <div id="layoutSidenav">

    <div id="layoutSidenav_nav">
      <a class="navbar-brand">
        <img src="assets/img/logo.png" alt="">
      </a>
      <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
        <div class="sb-sidenav-menu m-2">
          <div class="nav">

            <a class="nav-link" routerLink="/dashboard" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-house"></i></div>
              Home
            </a>

            <a class="nav-link" routerLink="/search/searchProp" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-magnifying-glass-location"></i></div>
              Search Property
            </a>
            <a class="nav-link" routerLink="Post-Property/propertyModules" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }" (click)="setActiveMenu('postProp');postProp()">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-bar"></i></div>
              List Property
            </a>
            <a class="nav-link" routerLink="/My-Properties" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }" (click)="setActiveMenu('myProp');myProp()">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-bar"></i></div>
              My Properties
            </a>
            <!-- <a class="nav-link"
            [ngClass]="{ 'custom-active text-white': selectedMenu === 'nexusNetwork' }"
            (click)="setActiveMenu('nexusNetwork'); nexusNetwork()">
           <div class="sb-nav-link-icon"><i class="fa-solid fa-magnifying-glass-location"></i></div>
           Nexus Network
         </a> -->
            <a class="nav-link" routerLink="/myStaff" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }" *ngIf="myStaff">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-users"></i></div>
              My Staff
            </a>

            <a class="nav-link" href="#" data-bs-toggle="collapse" data-bs-target="#leads" aria-expanded="false"
              aria-controls="leads">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-users-gear"></i></div>
              CRM
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <div class="collapse" id="leads" [ngClass]="{ 'show': isChildActive('/crm') }">
              <nav class="sb-sidenav-menu-nested nav">
                <a class="nav-link" routerLink="/Leads" routerLinkActive="custom-active text-white"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <i class="fa-solid fa-money-bill"></i> Leads
                </a>
              </nav>
              <nav class="sb-sidenav-menu-nested nav">
                <a class="nav-link" routerLink="/organizedLeads" routerLinkActive="custom-active text-white"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <i class="fa-solid fa-money-bill"></i> Opportunities
                </a>
              </nav>
              <nav class="sb-sidenav-menu-nested nav">
                <a class="nav-link" routerLink="/FollowUp" routerLinkActive="custom-active text-white"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <i class="fa-solid fa-money-bill"></i> Follow Up
                </a>
              </nav>
            </div>

            <!-- Leads Section -->
            <!-- <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'lead' }"
              (click)="setActiveMenu('lead');leads('lead')">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
              Leads
            </a> -->
            <!-- <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'organizedLeads' }"
              (click)="setActiveMenu('organizedLead');leads('organizedLeads')">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
              Opportunities
            </a> -->
            <!-- <a class="nav-link collapsed" [ngClass]="{ 'active bg-warning text-white': selectedMenu === 'leads' }"
               (click)="setActiveMenu('leads')" href="#" data-bs-toggle="collapse" data-bs-target="#leadsaddon"
                 aria-expanded="false" aria-controls="leadsaddon">
                 <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
                 Leads
                 <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
               </a>
               <div class="collapse" id="leadsaddon" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
                 <nav class="sb-sidenav-menu-nested nav">
                   <a class="nav-link"[ngClass]="{ 'custom-active text-white': selectedMenu === 'interested' }"
                   (click)="setActiveMenu('interested');leads('interested')">Interested Leads</a>
                   <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'dead' }"
                   (click)="setActiveMenu('dead');leads('dead')">Dead Leads</a>
                   <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'notinterested' }"
                   (click)="setActiveMenu('notinterested');leads('notinterested')">Not Interested Leads</a>
                 </nav>
               </div> -->
            <!-- <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'crmLeads' }"
              (click)="setActiveMenu('crmLeads');crmLeads()">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-users-gear"></i></div>
              CRM
            </a> -->
            <!-- <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'follow' }"
              (click)="setActiveMenu('follow');followup('follow')">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
              Follow <span class="text-danger ms-1"> Up</span>
            </a> -->
            <!-- <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#followupaddon"
               aria-expanded="false" aria-controls="followupaddon">
               <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
               Follow <span class="text-danger ms-1"> Up</span>
               <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
             </a>
             <div class="collapse" id="followupaddon" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
               <nav class="sb-sidenav-menu-nested nav">
                 <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'pending' }"
                 (click)="setActiveMenu('pending');followup('pending')">Pending FollowUp</a>
                 <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'today' }"
                 (click)="setActiveMenu('today');followup('today')">Today FollowUp</a>
                 <a class="nav-link"  [ngClass]="{ 'custom-active text-white': selectedMenu === 'complete' }"
                 (click)="setActiveMenu('complete');followup('complete')">Complete FollowUp</a>
 
               </nav>
             </div> -->
            <!-- <a class="nav-link" [ngClass]="{ 'custom-active text-white': selectedMenu === 'postProp' }"
             (click)="setActiveMenu('postProp');postProp()">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-chart-bar"></i></div>
              List Property
            </a> -->
            <a class="nav-link" *ngIf="mySubfranchise" routerLink="/My-Subfranchise"
              routerLinkActive="custom-active text-white" [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon">
                <img src="../../../assets/img/franchise.png" alt="">
              </div>
              Sub Franchises
            </a>

            <!-- <a class="nav-link"  [ngClass]="{ 'custom-active text-white': selectedMenu === 'servicePartners' }"
            (click)="setActiveMenu('servicePartners');servicePartner()">
              <div class="sb-nav-link-icon">
                 <i class="fa-solid fa-laptop"></i> -->
            <!-- <img src="../../../assets/img/team-badge.png" alt="">
              </div>
              Service Partners
            </a> -->


            <!-- Nexus Adon Section -->
            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#nexusaddon"
              aria-expanded="false" aria-controls="nexusaddon">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-money-bill"></i></div>
              Nexus <span class="text-danger ms-1"> Adon</span>
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>
            <div class="collapse" id="nexusaddon" aria-labelledby="headingOne" data-bs-parent="#sidenavAccordion">
              <ng-container *ngFor="let menu of menuOptions">
                <nav class="sb-sidenav-menu-nested nav" *ngFor="let submenu of menu.submenuList">
                  <a class="nav-link" (click)="openSubmenuItem(menu, submenu)">
                    <img src="{{submenu.sideSubMenuicon}}" />{{submenu.label}}
                  </a>
                </nav>
              </ng-container>
            </div>

            <a class="nav-link" routerLink="/sales" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon">
                <!-- <i class="fa-solid fa-laptop"></i> -->
                <img src="../../../assets/img/sale-tag.png" alt="">
              </div>
              Sales
            </a>

            <a class="nav-link" *ngIf="rsbLookup.getLoggedUser().type === 'franchise'" routerLink="/billing"
              routerLinkActive="custom-active text-white" [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon">
                <!-- <i class="fa-solid fa-laptop"></i> -->
                <i class="fa-solid fa-file-invoice-dollar"></i>
                <!-- <img src="../../../assets/img/bill.png" alt=""> -->
              </div>
              Billing
            </a>

            <a class="nav-link" routerLink="/Support&Help" routerLinkActive="custom-active text-white"
              [routerLinkActiveOptions]="{ exact: true }">
              <div class="sb-nav-link-icon"><i class="fa-solid fa-headset"></i></div>
              Support
            </a>
          </div>
          <button class="btn btn-desktop btn-sm sidebarToggle" href="#!"><i
              class="fa-solid fa-chevron-left"></i></button>
        </div>
        <!-- <div class="position-fixed bottom-0 start-0 m-3 mb-3">
          <div class="card refer_widget">
            <div class="card-body">
              <img src="assets/img/gift_icon.png" alt="">
              <span>Refer and <span class="text-primary"> earn</span> </span>
              <button class="btn btn-light">Invite friends</button>
            </div>
          </div>
        </div> -->
      </nav>
    </div>
  </div>
</div>